import PortalVue from 'portal-vue';
import Vue from 'vue';

export default {
    init() {
        Vue.use(PortalVue);
    },
};
